module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/016-nepal-3b5d4acafb2e07758c13f580c38f73aa.svg";